<template>
  <div class="container">
    <form class="account-form" autocomplete="off" @submit.prevent="onSave()">
      <div class="account-form__header">
        {{ pageHeader }}
      </div>
      <div class="account-form__content" :class="{'account-form__content_edit': editMode }">
        <div class="account-form__form-group">
          <span class="account-form__label" :class="{'account-form__label-not-edit': !editMode }">{{ firstNameTitle }}</span>
          <input :type="!editPassword ? 'text' : 'password'"
                 ref="firstName"
                 :name="!editPassword ? 'firstName' : 'old-password'"
                 maxlength="50"
                 :disabled="!editMode"
                 @focus="focusInput($event, 'firstName')"
                 :placeholder="editPassword ? 'Enter old password' : 'Enter first name'"
                 class="form-control"
                 :class="{ 'account-form__form-group_invalid': errors.has('firstName'), 'form-control-not-edit': !editMode }"
                 v-validate="'required'"
                 v-model="firstName">
          <span class="error__message">{{ errors.first('firstName') }}</span>
        </div>
        <div class="account-form__form-group">
          <span class="account-form__label" :class="{'account-form__label-not-edit': !editMode }">{{ lastNameTitle }}</span>
          <input :type="!editPassword ? 'text' : 'password'"
                 ref="lastName"
                 :name="!editPassword ? 'lastName' : 'new-password'"
                 maxlength="50"
                 :disabled="!editMode"
                 @focus="focusInput($event, 'lastName')"
                 :placeholder="editPassword ? 'Enter new password' : 'Enter last name'"
                 class="form-control"
                 :class="{ 'account-form__form-group_invalid': errors.has('lastName'), 'form-control-not-edit': !editMode }"
                 v-validate="'required'"
                 v-model="lastName">
          <span class="error__message">{{ errors.first('lastName') }}</span>
        </div>
        <div class="account-form__form-group">
          <span class="account-form__label" :class="{'account-form__label-not-edit': !editMode }">{{ emailTitle }}</span>
          <input :type="!editPassword ? 'text' : 'password'"
                 ref="email"
                 :name="!editPassword ? 'email' : 'confirm-password'"
                 :maxlength="editPassword ? 50 : 255"
                 :disabled="!editMode"
                 @focus="focusInput($event, 'email')"
                 :placeholder="editPassword ? 'Confirm new password' : 'Enter email'"
                 class="form-control"
                 :class="{ 'account-form__form-group_invalid': errors.has('email'), 'form-control-not-edit': !editMode }"
                 v-validate="editPassword ? 'required' : 'required|email'"
                 v-model="email">
          <span class="error__message">{{ errors.first('email') }}</span>
        </div>
      </div>
      <div class="account-form__footer" :class="{ 'account-form__footer_edit': editMode }">
        <template v-if="editMode">
          <button class="cancel-button" @click.prevent="onCancel">Cancel</button>
          <button class="save-button" :class="{ 'save-button_disabled': isChangePasswordDisabled }" type="submit">Save changes</button>
        </template>
        <template v-else>
          <button class="edit-button" @click.prevent="onEdit(false)">edit account details</button>
          <button class="edit-button" @click.prevent="onEdit(true)">Change password</button>
        </template>
      </div>
    </form>
    <div class="toolbar-links-wrapper">
<!--      <a type="input" onclick="return false;"-->
<!--         href="javascript:(function()%7Bfunction%20callback()%7B(function(%24)%7Bvar%20jQuery%3D%24%3Bfunction%20callback()%7Breturn%7Dvar%20s%3Ddocument.createElement(%22script%22)%3Bs.src%3D%22https%3A%2F%2Fadmin.reflexivemedia.com%2Fvendor%2F00a2b991d308be75b5a7acda8cc79a3b%22%3Bif(s.addEventListener)%7Bs.addEventListener(%22load%22%2Ccallback%2Cfalse)%7Delse%20if(s.readyState)%7Bs.onreadystatechange%3Dcallback%7Ddocument.body.appendChild(s)%3B%7D)(jQuery.noConflict(true))%7Dvar%20s%3Ddocument.createElement(%22script%22)%3Bs.src%3D%22https%3A%2F%2Fajax.googleapis.com%2Fajax%2Flibs%2Fjquery%2F1.11.1%2Fjquery.min.js%22%3Bif(s.addEventListener)%7Bs.addEventListener(%22load%22%2Ccallback%2Cfalse)%7Delse%20if(s.readyState)%7Bs.onreadystatechange%3Dcallback%7Ddocument.body.appendChild(s)%3B%7D)()">Link-->
<!--        Highlighter - Toolbar Shortcut (Drag to toolbar)</a>-->
      <a type="input" onclick="return false;" href="javascript: window.open('https://app.audiencekey.com/find-content-brief?url=' + encodeURIComponent(window.location.href));">Content Brief Locator - Toolbar Shortcut (Drag to toolbar)</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ToastService from '@/services/toasterService'

/**
 * User Account component
 */
export default {
  name: 'MyAccountEditMode',
  data () {
    return {
      email: '',
      firstName: '',
      lastName: '',
      // this properties are needed to restore form inputs after clicking Cancel button
      emailCopy: '',
      firstNameCopy: '',
      lastNameCopy: '',
      editPassword: false,
      editMode: false,
      blurAutocomplete: {
        email: false,
        firstName: false,
        lastName: false
      }
    }
  },
  watch: {
    currentUser () {
      this.setCurrentUser()
    }
  },
  computed: {
    ...mapState([
      'currentUser'
    ]),
    isFormInvalid () {
      return this.errors.any() ||
        ((this.fields.email && this.fields.email.pristine) &&
          (this.fields.firstName && this.fields.firstName.pristine) &&
          (this.fields.lastName && this.fields.lastName.pristine))
    },
    passwordPlaceholderColor () {
      return this.editMode ? 'dark' : 'light'
    },
    firstNameTitle () {
      return this.editPassword ? 'Old Password' : 'First Name'
    },
    lastNameTitle () {
      return this.editPassword ? 'New Password' : 'Last Name'
    },
    emailTitle () {
      return this.editPassword ? 'Confirm New Password' : 'Email'
    },
    pageHeader () {
      return this.editPassword ? 'Change Password' : this.editMode ? 'Edit My Account Details' : 'My Account'
    },
    isChangePasswordDisabled () {
      return this.editPassword && (!this.firstName || !this.lastName || !this.email)
    }
  },
  created () {
    this.setCurrentUser()
  },
  mounted () {
    this.setReadOnly()
  },
  methods: {
    ...mapActions([
      'updateProfile',
      'changePassword'
    ]),
    onSave: async function () {
      if (this.editPassword) {
        let passwordError = ''
        if (this.lastName.length < 6) {
          passwordError = 'Password must have at least 6 characters'
        } else if (!/[A-Z]/.test(this.lastName)) {
          passwordError = 'Password must have at least one uppercase letter'
        } else if (!/[a-z]/.test(this.lastName)) {
          passwordError = 'Password must have at least one lowercase letter'
        } else if (!/[0-9]/.test(this.lastName)) {
          passwordError = 'Password must have at least one number'
        }
        if (passwordError) {
          this.errors.add({
            field: 'lastName',
            msg: passwordError
          })
        }
        if (this.lastName !== this.email) {
          this.errors.add({
            field: 'email',
            msg: 'New Password and Confirm Password did not match'
          })
        }
      }
      if (this.isFormInvalid) {
        return
      }
      if (!this.editPassword) {
        const dataToUpdate = {
          email: this.email,
          first_name: this.firstName,
          last_name: this.lastName
        }
        await this.updateProfile({ clientId: this.currentUser._id, dataToUpdate })
      } else {
        const dataToUpdate = {
          old_pass: this.firstName,
          new_pass: this.lastName,
          confirm_pass: this.email
        }
        const isOldPasswordIncorrect = await this.changePassword({ userId: this.currentUser._id, dataToUpdate })
        if (isOldPasswordIncorrect === null) {
          return
        }
        if (!isOldPasswordIncorrect) {
          this.errors.add({
            field: 'firstName',
            msg: 'Old Password is incorrect'
          })
          return
        }
        ToastService.showToast(ToastService.SUCCESS_TYPE, 'Password changed successfully')
      }
      this.onCancel()
    },
    setReadOnly () {
      this.$refs.firstName.setAttribute('readonly', 'readonly')
      this.$refs.lastName.setAttribute('readonly', 'readonly')
      this.$refs.email.setAttribute('readonly', 'readonly')
    },
    onCancel () {
      this.editMode = false
      this.errors.clear()
      this.restoreInputs()
      this.editPassword && (this.editPassword = false)
      this.blurAutocomplete = {
        email: false,
        firstName: false,
        lastName: false
      }
      this.setReadOnly()
    },
    focusInput (event, name) {
      if (!this.blurAutocomplete[name]) {
        event.target.removeAttribute('readonly')
        event.target.readOnly = false
        this.blurAutocomplete[name] = true
      }
    },
    setCurrentUser () {
      this.firstName = this.currentUser ? this.currentUser.first_name : ''
      this.lastName = this.currentUser ? this.currentUser.last_name : ''
      this.email = this.currentUser ? this.currentUser.email : ''

      this.firstNameCopy = this.firstName
      this.lastNameCopy = this.lastName
      this.emailCopy = this.email
    },
    restoreInputs () {
      this.firstName = this.firstNameCopy
      this.lastName = this.lastNameCopy
      this.email = this.emailCopy
    },
    onEdit (isPassword = false) {
      this.editMode = true
      this.editPassword = isPassword
      if (isPassword) {
        this.firstName = ''
        this.lastName = ''
        this.email = ''
      }
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.errors.clear()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">

  .toolbar-links-wrapper {
    padding-top: 56px;
    padding-left: 56px;
    display: flex;
    flex-direction: column;

    a {
      margin-bottom: 14px;
    }
  }

  .bright-background {
    background: white;
  }

  // to remove forced yellow input background in Chrome
  // https://webagility.com/posts/remove-forced-yellow-input-background-in-chrome
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
  }

  .account-form {
    box-sizing: border-box;
    width: -webkit-fill-available;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(96, 97, 112, 0.16), 0 0 1px 0 rgba(40, 41, 61, 0.04);

    &__header {
      width: -webkit-fill-available;
      font-weight: 500;
      font-size: 24px;
      line-height: 40px;
      padding: 16px 24px;
    }

    &__content {
      padding: 56px;
      border-bottom: 1px solid #dbdee5;
      border-top: 1px solid #dbdee5;

      &_edit {
        .account-form__form-group:not(:first-child) {
          margin-top: 24px;
        }
      }
    }

    &__footer {
      display: flex;
      padding: 56px;
      max-width: 500px;

      &_edit {
        justify-content: flex-end;
        padding-right: 0;
      }
    }

    &__label {
      display: block;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 12px;
      letter-spacing: 0;
      line-height: normal;
      color: $rfx-dark-march;
    }

    &__label-not-edit {
      color: $rfx-shaded-grey !important;
    }

    &__form-group {
      display: flex;
      flex-direction: column;
      position: relative;

      &_invalid[type='email'],
      &_invalid[type='password'],
      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }

      input {
        &:disabled {
          background-color: transparent !important;
        }
      }
    }

    &__form-group:not(:first-child) {
      margin-top: 40px;
    }
  }

  .error {
    &__message {
      color: $rfx-red;
      font-size: 10px;
      margin-top: 5px;
    }
  }

  .form-control {
    padding: 0 15px;
    border: 1px solid #dbdee5;
    outline: none;
    border-radius: 4px;
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;
    color: $rfx-dark-march;
    max-width: 468px;
  }

  .form-control-not-edit {
    @extend .form-control;
    padding: 0;
    font-size: 24px;
    line-height: 32px;
    height: 32px;
    font-weight: 500;
    color: $rfx-medium-march;
    border: none;
  }

  .password-container {
    display: flex;
    padding-top: 20px;

    &__password-placeholder {
      flex: 1 1;
      display: inline;
    }

    &__change-password {
      display: inline;
      align-self: flex-end;
      font-size: 13px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: -0.2px;
      text-transform: uppercase;
      text-align: center;
      color: #284aff;
    }

    &__change-password:hover {
      cursor: pointer;
    }
  }

  .save-button {
    padding: 0 22px;
    background-color: $rfx-medium-march;
    text-transform: uppercase;
    color: white;
    position: relative;
    border-radius: 4px;
    // fix for safari
    border: none;

    font-size: 10px;
    font-weight: 900;
    line-height: 40px;
    height: 40px;
    letter-spacing: 1.25px;

    &_disabled {
      pointer-events: none;
      opacity: .4;
    }
  }

  .cancel-button {
    @extend .save-button;
    color: #011627;
    background-color: rgba(1, 22, 39, 0.0);
    margin-right: 19px;
    border: none;
    width: auto;
  }

  .edit-button {
    @extend .save-button;
    margin-right: 24px;
  }

  .save-button:hover {
    cursor: pointer;
  }

  .edit-button:focus {
    outline: 0;
  }

  .save-button:focus {
    outline: 0;
  }

</style>
